import Typography from "@mui/joy/Typography";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import { useTranslation } from "../../../i18n";
import { Link as RouterLink, Outlet, useLocation } from "react-router-dom";
import { useTeam } from "../TeamLayout";
import { Breadcrumbs, Link } from "@mui/joy";
import HomeIcon from "@mui/icons-material/Home";

export default function Settings() {
  const t = useTranslation();
  const teamCtx = useTeam();
  const location = useLocation();
  let currentTab = location.pathname.split("/").pop();
  if (!currentTab || currentTab === "settings") {
    currentTab = "general";
  }

  return (
    <>
      <Breadcrumbs
        aria-label="breadcrumbs"
        sx={{
          "--Breadcrumbs-gap": "4px",
          m: 1,
        }}
        size="sm"
      >
        <Link component={RouterLink} color="neutral" to="/">
          <HomeIcon />
        </Link>
        <Link
          component={RouterLink}
          color="neutral"
          to={`/${teamCtx.team.slug}`}
        >
          {teamCtx.team.name}
        </Link>
        <Typography level="title-sm">{t("Settings")}</Typography>
      </Breadcrumbs>
      <Tabs
        sx={{
          bgcolor: "transparent",
          m: 0,
          pt: 2,
        }}
        value={currentTab}
      >
        <TabList
          variant="outlined"
          disableUnderline
          sx={{
            m: 2,
            mt: 0,
            mb: 0,
            gap: 0.5,
            borderRadius: "sm",
            bgcolor: "background.level2",
            overflow: "hidden",
            [`& .${tabClasses.root}`]: {
              border: 0,
              borderRight: "1px solid",
              borderColor: "divider",
            },
            [`& .${tabClasses.root}:last-of-type`]: {
              borderRight: "none",
            },
            [`& .${tabClasses.root}[aria-selected="true"]`]: {
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
              borderRadius: "sm",
              bgcolor: "neutral.900", // Darker for better contrast
              color: "neutral.100",
              fontWeight: "bold",
            },
            [`& .${tabClasses.root}:hover`]: {
              borderRadius: "sm",
              bgcolor: "neutral.800", // Lighter than selected, darker than default
              color: "neutral.50", // Slightly brighter text
              boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.4)", // Stronger shadow for a lift effect
              transition:
                "background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
            },
          }}
        >
          <Tab
            disableIndicator
            component={RouterLink}
            relative="path"
            to={"general"}
            value="general"
          >
            {t("Appearance")}
          </Tab>
          <Tab
            disableIndicator
            component={RouterLink}
            relative="path"
            to={"members"}
            value="members"
          >
            {t("Members")}
          </Tab>
          <Tab
            disableIndicator
            component={RouterLink}
            relative="path"
            to={"integrations"}
            value="integrations"
          >
            {t("Integrations")}
          </Tab>
        </TabList>
        <Outlet context={teamCtx} />
      </Tabs>
    </>
  );
}
